import React, { useEffect, useState } from "react";
import "../Dashboard.scss";
import { Row, Col, Progress } from "reactstrap";
import { connect } from "react-redux";
import Faker from "faker";
import "./HCDashboard.scss";
import Banner from "../Banner";
import HCLeaves from "./HCLeaves";
import gql from "graphql-tag";
import { useQuery } from "react-apollo";
import Attendance from "./Attendance/Attendance";
import Calendar from "./Attendance/Calendar";
import AttendanceStats from "./Attendance/AttendanceStats"
import Reimbursement from "./Reimbursement/Reimbursement"

const doughnut = {
  labels: ["Red", "Green", "Yellow"],
  options: {
    title: {
      display: true,
      text: "Best!",
      position: "left"
    },
    legend: {
      position: "right"
    }
  },
  datasets: [
    {
      data: [300, 50, 100],
      backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
      hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"]
    }
  ]
};
const doughnutProspect = {
  labels: [
    "Get Information",
    "Preliminary Discuss",
    "Offering Letter",
    "Deal",
    "Fail"
  ],
  options: {
    title: {
      display: true,
      text: "Best!",
      position: "left"
    },
    legend: {
      position: "right"
    }
  },
  datasets: [
    {
      data: [300, 50, 100, 20, 92],
      backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#673ab7", "#20c997"],
      hoverBackgroundColor: [
        "#FF6384",
        "#36A2EB",
        "#FFCE56",
        "#673ab7",
        "#20c997"
      ]
    }
  ]
};

const HCDashboard = props => {
  
  return (
    <div className="animated fadeIn">
      <Row>
        <Col md="12">
          <Banner />
        </Col>
      </Row>
      <br />
      <Row>
        <Col md="12">
          <Row>
            <Col>
              <div className="section p5">
                <div className="sectioncontent">
                  <h5 className="blocktext">Attendance Calendar</h5>
                  <Calendar />
                </div>
              </div>
            </Col>
          </Row>
          <br />
          {/* <Row>
            <Col>
              <div className="section p5">
                <div className="sectioncontent">
                  <h5 className="blocktext">List Attendance</h5>
                  <Attendance />
                </div>
              </div>
            </Col>
          </Row> */}
        </Col>
        <Col md="12">
          <AttendanceStats />
        </Col>
      </Row>
      <br />
        <Reimbursement />
      <br />
      <Row>
        <Col md="12">
          <HCLeaves />
        </Col>
      </Row>
    </div>
  );
};

export default connect(store => ({}))(HCDashboard);
